<template>
  <div>
    <BaseSheet>
      <v-form ref="brandProviderForm" v-model="valid" lazy-validation>
        <v-container class="mx-0 mt-0" fluid>
          <v-row>
            <v-col cols="12" lg="12" md="12" sm="12" xl="12">
              <v-card elevation="6">
                <v-toolbar color="grey lighten-2" flat dense>
                  <v-toolbar-title>Common</v-toolbar-title>
                </v-toolbar>
                <v-row dense class="mt-5 mx-1" justify="space-between">
                  <v-col cols="6">
                    <v-text-field
                        label="Name"
                        :key="ignoreFlag"
                        v-model="brandProviderItem.name"
                        :rules="nameRules"
                        required outlined dense
                        disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                        label="Brief name"
                        :key="ignoreFlag"
                        v-model="brandProviderItem.brief_name"
                        :rules="nameRules"
                        disabled
                        required outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-textarea label="Address"
                                :key="ignoreFlag"
                                v-model="brandProviderItem.address"
                                required outlined dense></v-textarea>
                  </v-col>
                  <v-col cols="6">
                    <v-textarea label="Notes"
                                :key="ignoreFlag"
                                v-model="brandProviderItem.notes"
                                required outlined dense></v-textarea>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field label="Phone"
                                  :key="ignoreFlag"
                                  v-model="brandProviderItem.phone"
                                  required outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field label="URL"
                                  :key="ignoreFlag"
                                  v-model="brandProviderItem.url"
                                  required outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="1">
                    <v-text-field label="Lead day"
                                  :key="ignoreFlag"
                                  v-model="brandProviderItem.lead_day"
                                  required outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="1">
                    <v-text-field label="Cache hours"
                                  :key="ignoreFlag"
                                  v-model="brandProviderItem.cache_hours"
                                  required outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="1">
                    <v-text-field label="Priority" :key="ignoreFlag" v-model="brandProviderItem.priority" required
                                  outlined dense>
                    </v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox label="Search enable" v-model="brandProviderItem.scrap_enable" required outlined dense>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="12" md="12" sm="12" xl="12">
              <BrandProviderCheckList :brandProviderId="this.$route.params.brandProviderId"></BrandProviderCheckList>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <template v-slot:footer>
        <v-toolbar flat dense>
          <v-tooltip top v-if="brandProviderItem.service_redirect != null">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  class="mr-4"
                  :href="brandProviderItem.service_redirect"
                  target="_blank"
                  v-on="on"
              >
                Redirect
              </v-btn>
            </template>
            <span>{{brandProviderItem.service_redirect_text}}</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <BaseConformSave class="mr-4" :on-save-external="submit" color="primary"
                           :disabled="!valid || saving"
                           :loading="saving">
          </BaseConformSave>
          <v-btn class="mr-4" :to="{name: 'BrandProviderList'}">
            Cancel
          </v-btn>
        </v-toolbar>
      </template>
    </BaseSheet>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {createHelpers} from 'vuex-map-fields'

import {required, digits, email, max, regex} from 'vee-validate/dist/rules'
import {extend, ValidationObserver, ValidationProvider, setInteractionMode} from 'vee-validate'
import BrandProviderCheckList from "@/components/Brand/BrandProviderCheckList";

const {mapFields} = createHelpers({
  getterType: 'getFieldBrandProviderItem',
  mutationType: 'updateFieldBrandProviderItem',
});

setInteractionMode('eager')

extend('digits', {
  ...digits,
  message: '{_field_} needs to be {length} digits. ({_value_})',
})

extend('required', {
  ...required,
  message: '{_field_} can not be empty',
})

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
})

extend('regex', {
  ...regex,
  message: '{_field_} {_value_} does not match {regex}',
})

extend('email', {
  ...email,
  message: 'Email must be valid',
})

export default {
  name: 'BrandProviderItem',
  props: ['brandProviderId'],

  components: {
    ValidationProvider,
    ValidationObserver,
    BrandProviderCheckList
  },

  computed: {
    ...mapGetters(['getBrandProviderItem']),
    ...mapFields([
      'brandProviderItem',
    ]),
  },
  methods: {
    ...mapActions(['fetchBrandProviderItem', 'saveBrandProviderItem']),
    submit() {
      console.log('on-save-external')
      this.saving = true
      console.log(this.$root.$store.state.BrandProviderItem)
      this.saveBrandProviderItem(this.$route.params.brandProviderId)
      this.saving = false
    },
    cancel() {
      this.ignoreFlag = !this.ignoreFlag
      this.fetchBrandProviderList()
    },
    validate() {
      this.$refs.form.validate()
    },
  },

  async mounted() {
    this.fetchBrandProviderItem(this.$route.params.brandProviderId)
  },

  data() {
    return {
      valid: true,
      saving: false,
      ignoreFlag: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 50) || 'Name must be less than 50 characters',
      ],
      linkRules: [],
    }
  },

}
</script>

<style scoped lang="scss">
</style>
